import type { Flow, FlowRun } from '../types';

/**
 * Whether a standard flow entry opens in voice mode: either requested with
 * `?mode=voice`, or restored for an in-progress run last used in voice mode.
 * `?mode=standard` always opens the ordinary question flow.
 */
export const opensInVoiceMode = (
  flow: Pick<Flow, 'voice_mode_available'>,
  flowRun: Pick<FlowRun, 'last_interaction_mode' | 'status'> | null | undefined,
  requestedMode: string | null | undefined,
): boolean => {
  if (!flow.voice_mode_available || requestedMode === 'standard') {
    return false;
  }
  if (requestedMode === 'voice') {
    return true;
  }
  return !requestedMode && flowRun?.last_interaction_mode === 'voice' && flowRun?.status === 'in_progress';
};
